import firebase from '@modules/firebase';

function formatSSOProvider(providerId: string) {
  switch (providerId) {
    case 'google.com':
      return 'Google account';
    case 'microsoft.com':
      return 'Microsoft account';
    case 'apple.com':
      return 'Apple ID';
  }
}

export function getMessageForError(error: firebase.auth.Error) {
  switch (error.code) {
    case 'auth/invalid-email':
      return 'The email address provided is not valid';
    case 'auth/wrong-password':
      return 'Wrong password';
    case 'auth/user-not-found':
      return 'There is no Blinq account associated with this email address. Click the sign up button to create a new account instead.';
    case 'auth/network-request-failed':
      return 'We are sorry, something went wrong with the login process. Please try again in 1 to 2 minutes.';
    case 'auth/account-exists-with-different-credential': {
      const provider = localStorage.getItem('ssoMethod'); // This is set in `FirebaseAuthService.redirectToProvider`
      const formatted = provider ? formatSSOProvider(provider) : 'account';
      return `Your ${formatted} has already been used to sign into an existing Blinq account. If you still want to create a new Blinq account you will need to use a different method.`;
    }
    case 'auth/email-already-in-use':
      return 'This email address is already in use by another account, please sign in to that account.';
    case 'auth/invalid-action-code':
      return 'This login link has expired. Please click the button below to go back to the login screen.';
    case 'auth/credential-already-in-use': {
      const provider = localStorage.getItem('ssoMethod'); // This is set in `FirebaseAuthService.redirectToProvider`
      const formatted = provider ? formatSSOProvider(provider) : 'account';
      return `Your ${formatted} has already been used to sign into an existing Blinq account. If you still want to create a new Blinq account you will need to use a different method.`;
    }
    case 'auth/timeout':
      return 'The operation timed out, please try again.';
    case 'auth/weak-password':
      return 'The password is too weak. Please use at least 10 characters.';
    default:
      return 'An error occurred, please try again.';
  }
}
